import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const UsersState = (state: RootState) => state.careWorkers.users;

export const selectUsers = (state: RootState) => UsersState(state).rows;
export const selectUsersTotal = (state: RootState) => UsersState(state).total;
export const selectCurrentUser = (state: RootState) => UsersState(state).row;
export const selectLookupUsers = createSelector(selectUsers, (rows) =>
  rows.map(({ id, full_name }) => ({ id, name: `${full_name}` })),
);
export const selectLookupCareWorkers = createSelector(selectUsers, (rows) =>
  rows.map(({ id, full_name, pay_level }) => ({
    id,
    name: `${full_name} ${pay_level?.name && `(${pay_level.name})`}`,
  })),
);
export const selectCareWorkerOptions = createSelector(selectUsers, (rows) =>
  rows.map(({ id, full_name }) => ({
    value: id,
    label: full_name ?? '',
  })),
);

export const selectUserByID = createSelector([selectUsers, (_: RootState, id?: number) => id], (rows, id) =>
  rows.find(({ id: rowId }) => id === rowId),
);

export const selectLocations = (state: RootState) => UsersState(state).locations;
export const selectUserAvailability = (state: RootState) => UsersState(state).availability;
export const selectUsersLoading = (state: RootState) => UsersState(state).loading;
export const selectUsersErrorResponse = (state: RootState) => UsersState(state).error;

// Options for users who can have access tags assigned to them
export const selectAccessTagQuickAddOptions = createSelector(selectUsers, (rows) =>
  rows
    .filter(({ accounts_access_enabled, unlocking_permissions }) => !accounts_access_enabled && !unlocking_permissions)
    .map(({ id, full_name }) => ({
      value: id,
      label: full_name ?? '',
    })),
);

// Users who can assign access tags to others
export const selectAccessTagAdminUsers = createSelector(selectUsers, (rows) =>
  rows
    .filter(({ accounts_access_enabled, unlocking_permissions }) => accounts_access_enabled || unlocking_permissions)
    .map(({ id, full_name, accounts_access_enabled, unlocking_permissions }) => {
      let label = full_name ?? '';

      if (accounts_access_enabled && unlocking_permissions) {
        label += ' (Accounts / Administrator)';
      } else if (accounts_access_enabled) {
        label += ' (Accounts)';
      } else if (unlocking_permissions) {
        label += ' (Administrator)';
      }

      return {
        id,
        full_name: label,
      };
    }),
);
